"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("../styles");

var _element = require("../utils/dom/element");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var focusSelectAll = function focusSelectAll(element) {
  requestAnimationFrame(function () {
    _element.focusElement.select(element);
  });
};

var handleFocus = function handleFocus(e) {
  e.stopPropagation();
};

var FilterInput =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(FilterInput, _Component);

  function FilterInput(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleInput = _this.handleInput.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handlePaste = _this.handlePaste.bind(_assertThisInitialized(_assertThisInitialized(_this))); // for mutiple select

    _this.props.setInputReset(_this.reset.bind(_assertThisInitialized(_assertThisInitialized(_this))));

    return _this;
  }

  var _proto = FilterInput.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.focus) {
      this.props.onInputFocus();
      this.focus();
    }
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate() {
    return this.props.updatAble;
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.focus === prevProps.focus || !this.props.focus) return;
    this.props.onInputFocus();
    this.focus();
  };

  _proto.getProcessedValue = function getProcessedValue(text) {
    var trim = this.props.trim;
    if (!trim && this.lastCursorOffset === 0 && /^\u00A0$/.test(text)) return '';
    return trim ? text.trim() : text.replace(/\u00A0/g, ' ');
  };

  _proto.reset = function reset() {
    if (this.editElement) this.editElement.innerText = '';
    if (this.blurTimer) clearTimeout(this.blurTimer);
  };

  _proto.focus = function focus() {
    focusSelectAll(this.editElement);
  };

  _proto.bindElement = function bindElement(el) {
    this.editElement = el;
  };

  _proto.handleInput = function handleInput(e) {
    var text = e.target.innerText.replace('\feff ', '');
    this.lastCursorOffset = (0, _element.getCursorOffset)(text.length);
    this.props.onFilter(this.getProcessedValue(text));
  };

  _proto.handleBlur = function handleBlur(e) {
    var text = e.target.innerText.replace('\feff ', '');
    this.props.onInputBlur(this.getProcessedValue(text));
  };

  _proto.handlePaste = function handlePaste(e) {
    var text = (e.clipboardData || window.clipboardData).getData('text');
    if (!text) return;
    e.preventDefault();
    this.editElement.innerText = text;

    _element.focusElement.end(this.editElement);

    this.handleInput({
      target: {
        innerText: text
      }
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        text = _this$props.text,
        focus = _this$props.focus,
        multiple = _this$props.multiple;
    var value = typeof text === 'string' ? text.replace(/<\/?[^>]*>/g, '') : text;

    if ((0, _react.isValidElement)(value)) {
      return (0, _react.cloneElement)(value, {
        className: (0, _styles.selectClass)('input', !focus && 'ellipsis', !multiple && 'full'),
        ref: this.bindElement,
        key: 'input',
        onInput: this.handleInput,
        contentEditable: focus
      });
    }

    return _react.default.createElement("span", {
      key: "input",
      className: (0, _styles.selectClass)('input', !focus && 'ellipsis', !multiple && 'full'),
      ref: this.bindElement,
      contentEditable: focus,
      onInput: this.handleInput,
      onFocus: handleFocus,
      onBlur: this.handleBlur,
      onPaste: this.handlePaste,
      dangerouslySetInnerHTML: {
        __html: value
      }
    });
  };

  return FilterInput;
}(_react.Component);

FilterInput.propTypes = {
  focus: _propTypes.default.bool.isRequired,
  multiple: _propTypes.default.bool,
  onFilter: _propTypes.default.func.isRequired,
  onInputBlur: _propTypes.default.func.isRequired,
  onInputFocus: _propTypes.default.func.isRequired,
  updatAble: _propTypes.default.bool,
  setInputReset: _propTypes.default.func.isRequired,
  text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  trim: _propTypes.default.bool
};
FilterInput.defaultProps = {
  text: '',
  updatAble: false
};
var _default = FilterInput;
exports.default = _default;